import React, { createContext, useContext, useMemo, useState } from "react";
import pt from "./translations/pt";
import en from "./translations/en";

const dictionaries = { pt, en };
const STORAGE_KEY = "sge_locale";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(localStorage.getItem(STORAGE_KEY) || "pt");

  const changeLocale = (next) => {
    if (!dictionaries[next]) return;
    setLocale(next);
    localStorage.setItem(STORAGE_KEY, next);
  };

  const t = useMemo(() => {
    const dict = dictionaries[locale] || dictionaries.pt;
    return (key, params) => {
      let str = dict[key] || dictionaries.pt[key] || key;
      if (params) {
        Object.keys(params).forEach((param) => {
          str = str.replace(`{${param}}`, params[param]);
        });
      }
      return str;
    };
  }, [locale]);

  const value = useMemo(() => ({ locale, changeLocale, t }), [locale, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useTranslation = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error("useTranslation must be used within an I18nProvider");
  }
  return ctx;
};
